enum ENVIRONMENT_TYPE {
  LOCAL = 'local',
  INTEGRATION = 'integration',
  PRODUCTION = 'production',
}

type EnvironmentType = ENVIRONMENT_TYPE;

// TODO: Ideally we should get the environment from the config.
// We will address this on RCO-8850 and then this method should not be needed anymore.
function getEnvironment(isProduction: boolean): EnvironmentType {
  const hostname: string = window.location.hostname;
  
  if (hostname === 'localhost') {
    return ENVIRONMENT_TYPE.LOCAL;
  } else if (isProduction) {
    return ENVIRONMENT_TYPE.PRODUCTION; 
  } else {
    return ENVIRONMENT_TYPE.INTEGRATION;
  }
}

export {
  ENVIRONMENT_TYPE,
  EnvironmentType,
  getEnvironment,
};

export default getEnvironment;